import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getFormattedNumber } from "@utils";

const Modal = styled(AntModal)`
    .ant-modal-title {
        text-align: center;
        color: ${props => props.theme.primaryColor};
    }

    .ant-modal-content {
        text-align: center;
        white-space: pre-line;
    }

    .ant-modal-footer {
        text-align: center;
    }
`;

const BonusConfirmModal = ({
    exceed_bonus_limit,
    total_amount,
    max_topup_reward,
    amount,
    bonus_percent,
    open,
    onBonusAccept,
    handleClose,
}) => {
    const { t } = useTranslation()

    const calculateBonus = () => {
        return exceed_bonus_limit ? max_topup_reward : Math.ceil(amount * bonus_percent * 0.01);
    }

    const calculateTotal = () => {
        return exceed_bonus_limit ? total_amount : (amount + calculateBonus());
    }

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            open={open}
            width={320}
            title={t("wallet.topUpBonusTitle")}
            onCancel={handleClose}
            onOk={onBonusAccept}
            okText={t("wallet.accept")}
            cancelText={t("wallet.reject")}
        >
            {t("wallet.bonusConfirmMessage", {
                bonus_percent,
                amount: getFormattedNumber(amount),
                bonus_amount: getFormattedNumber(calculateBonus()),
                total: getFormattedNumber(calculateTotal()),
            })}
            <div>
                {exceed_bonus_limit && t("wallet.maxBonusAmount", { max_topup_reward: getFormattedNumber(max_topup_reward) })}
            </div>
        </Modal>
    );
}

export default BonusConfirmModal;